import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import Spinner from '@atlaskit/spinner';
import EmojiPickerCategoryHeading from './EmojiPickerCategoryHeading';
import EmojiPickerEmojiRow from './EmojiPickerEmojiRow';
import { sizes } from './EmojiPickerSizes';
import { emojiPickerSpinner } from './styles';
export class AbstractItem {
  constructor(props, height) {
    this.props = props;
    this.height = height;
  }

}
export class EmojisRowItem extends AbstractItem {
  constructor(props) {
    super(props, sizes.emojiRowHeight);

    _defineProperty(this, "renderItem", () => jsx(EmojiPickerEmojiRow, this.props));
  }

}
export class LoadingItem extends AbstractItem {
  constructor() {
    super({}, sizes.loadingRowHeight);

    _defineProperty(this, "renderItem", () => jsx("div", {
      css: emojiPickerSpinner
    }, jsx("div", null, jsx(Spinner, {
      size: "medium"
    }))));
  }

}
export class CategoryHeadingItem extends AbstractItem {
  constructor(props) {
    super(props, sizes.categoryHeadingHeight);

    _defineProperty(this, "renderItem", () => jsx(EmojiPickerCategoryHeading, this.props));
  }

}
/**
 * These are the values provided by react-virtualized.
 */

export const virtualItemRenderer = (rows, context) => {
  const {
    index,
    key,
    style
  } = context;
  const row = rows[index];
  return jsx("div", {
    style: style,
    key: key
  }, row.renderItem(context));
};